import { gql } from "@apollo/client";

export const GENERATE_DYNO = gql`
  mutation CreateDynoForDynosPlus($where: createDynoForDynosPlusWhereInput!) {
    createDynoForDynosPlus(where: $where) {
      id
      dynoTitle
    }
  }
`;

export const CREATE_CLASS = gql`
  mutation CreateOrganizationClass($data: OrganizationClassCreateInput!) {
    createOrganizationClass(data: $data) {
      id
      name
      isActive
      grade {
        gradeName
      }
      subject {
        subjectName
      }
      primaryCreator {
        firstName
        lastName
      }
    }
  }
`;
export const UPDATE_CLASS = gql`
  mutation UpdateOrganizationClass(
    $where: OrganizationClassWhereUniqueInput!
    $data: OrganizationClassUpdateInput!
  ) {
    updateOrganizationClass(where: $where, data: $data) {
      id
      name
    }
  }
`;
export const CREATE_CHILD = gql`
  mutation InviteDynoPlusStudent($data: InviteDynoPlusStudentDataUniqueInput!) {
    inviteDynoPlusStudent(data: $data) {
      id
      firstName
      lastName
      username
      pwd
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation ResetPasswordDynosPlusStudent(
    $where: ResetPasswordDynosPlusStudentWhereInput!
  ) {
    resetPasswordDynosPlusStudent(where: $where)
  }
`;
export const UPDATE_DYNO = gql`
  mutation UpdateDyno($where: DynoWhereUniqueInput!, $data: DynoUpdateInput!) {
    updateDyno(where: $where, data: $data) {
      id
      dynoTitle
      status {
        id
        statusType
      }
    }
  }
`;
export const CREATE_MODULE = gql`
  mutation CreateCollectionModule($data: CollectionModuleCreateInput!) {
    createCollectionModule(data: $data) {
      id
      moduleName
      dynosUnderModule {
        id
        dynoTitle
      }
    }
  }
`;
export const UPDATE_MODULE = gql`
  mutation UpdateCollectionModule(
    $data: CollectionModuleUpdateInput!
    $where: CollectionModuleWhereUniqueInput!
  ) {
    updateCollectionModule(data: $data, where: $where) {
      id
      moduleName
      dynosUnderModule {
        id
        dynoTitle
      }
    }
  }
`;
export const REMOVE_DYNO_FROM_MODULE = gql`
  mutation RemoveDynoFromModule($where: RemoveDynoFromModuleWhereInput!) {
    removeDynoFromModule(where: $where)
  }
`;
export const ADD_SUBSCRIBER = gql`
  mutation AddSubscriber(
    $data: OrganizationClassUpdateInput!
    $where: OrganizationClassWhereUniqueInput!
  ) {
    updateOrganizationClass(data: $data, where: $where) {
      id
      subscribers {
        id
        firstName
        lastName
        username
      }
    }
  }
`;
export const REMOVE_SUBSCRIBER = gql`
  mutation RemoveSubscriber($where: RemoveSubscriberFromClassWhereInput!) {
    removeSubscriberFromClass(where: $where)
  }
`;
export const UPDATEUSER = gql`
  mutation UpdateUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
    updateUser(data: $data, where: $where) {
      id
      organizations {
        id
        name
        email
        organizationType {
          id
          name
        }
        address {
          id
          street1
          street2
          city
          state
          zipcode
          country
        }
      }
    }
  }
`;
export const CREATEORG = gql`
  mutation CreateOrg($data: OrganizationCreateInput!) {
    createOrganization(data: $data) {
      id
      name
      email
      organizationType {
        id
        name
      }
      address {
        id
        street1
        street2
        city
        state
        zipcode
        country
      }
    }
  }
`;
